// Swap Quote

import BigNumber from 'bignumber.js'
import { CLPool, SwapQuote, Token } from '../atoms'
import { Network } from '../services/token.service'
import { simulateSwapV3 } from './amm_v3'
import { getAllCLPools } from '../model/clpool/helper'

const MIN_SQRT_RATIO_PLUS_1: string = '4295128740'
const MAX_SQRT_RATIO_MINUS_1: string = '1461446703485210103287273052203988822378723970341'

let calcId = 0
export function updateCalcId() {
    calcId = calcId + 1
}

export function getCalcId() {
    return calcId
}

async function getQuotesFromSwapSimulation(pools: CLPool[], oneForTwo: boolean, amount: string, exactInput: boolean, network: Network) {
    const quoteSimulationPromises = pools.map(async (pool) => {
        if (pool === undefined) {
            return undefined
        }
        console.log('YSYS simulate on pool fee=', pool.fee, ' oneForTwo=', oneForTwo)
        try {
            return await simulateSwapV3(network, pool, oneForTwo, amount, exactInput, oneForTwo ? MIN_SQRT_RATIO_PLUS_1 : MAX_SQRT_RATIO_MINUS_1)
        } catch (e) {
            console.log('YSYS error on fee=', pool.fee, 'err=', e)
            throw new Error('Resource busy')
            // return undefined
        }
    })

    return quoteSimulationPromises
}

function getBestQuoteFromQuotes(quotes: (SwapQuote | undefined)[], oneForTwo: boolean, exactInput: boolean) {
    let bestTokenPrice = BigNumber(0)
    let bestQuote = undefined
    let partialAmount = false
    for (const q of quotes) {
        if (q === undefined) return
        if (oneForTwo) {
            const quotedAmount = exactInput ? q.token2AmountWei : q.token1AmountWei
            const inAmount = exactInput ? q.token1AmountWei : q.token2AmountWei

            if (inAmount && quotedAmount) {
                if (BigNumber(q.requestedAmountWei).comparedTo(BigNumber(inAmount)) !== 0) {
                    partialAmount = true
                    continue
                }

                const thisq = BigNumber(quotedAmount)
                if (thisq.comparedTo(bestTokenPrice) == 1) {
                    bestTokenPrice = thisq
                    bestQuote = q
                }
            }
        } else {
            const quotedAmount = exactInput ? q.token1AmountWei : q.token2AmountWei
            const inAmount = exactInput ? q.token2AmountWei : q.token1AmountWei
            if (inAmount && quotedAmount) {
                if (BigNumber(q.requestedAmountWei).comparedTo(BigNumber(inAmount)) !== 0) {
                    partialAmount = true
                    continue
                }
                const thisq = BigNumber(quotedAmount)
                if (thisq.comparedTo(bestTokenPrice) == 1) {
                    bestTokenPrice = thisq

                    // got to flip the Quote for the UI
                    // as the UI has token1,token2 in reverse
                    bestQuote = q //flipTokens(q)
                }
            }
        }
    }
    return { bestQuote: bestQuote, partialAmount: partialAmount }
}

export async function getSwapQuote(
    network: Network,
    token1: Token,
    token2: Token,
    amount: string,
    exactInput: boolean,
    slippage: number,
    calculationId?: number
): Promise<SwapQuote | undefined> {
    // get all relevant pools
    const allPools = await getAllCLPools(network, token1, token2)
    // console.log('allPools ', allPools)
    const pools = allPools.filter((pool) => pool.address) // only relevant pools

    if (pools.length === 0) {
        // no available pools
        throw new Error('no pools support this swap')
    }

    // pool token order could be reversed than what is requested here
    const examplePool = pools[0] // just take first pool - they all must have same order of tokens
    //const tokensAreReversed = examplePool.token1 === token1
    const oneForTwo = examplePool.token1.address.toLowerCase() === token1.address.toLowerCase()

    if (examplePool.token1.address !== token1.address && examplePool.token2.address !== token1.address) {
        throw 'Mismatch between getAllCLPools and UI'
    }

    try {
        const quoteSimulationPromises = await getQuotesFromSwapSimulation(pools, oneForTwo, amount, exactInput, network)
        const quotes: Array<SwapQuote | undefined> = (await Promise.all(quoteSimulationPromises)).filter((x) => x !== undefined)

        // return best quote
        if (calcId !== calculationId) {
            console.log('Replacement calculation sent')
            throw new Error('Replacement calculation sent')
        }
        console.log('YSYS Quotes len=', quotes.length, quotes)
        if (quotes.length === 0) {
            throw new Error('not enough liquidity for this swap')
        }
        const response = getBestQuoteFromQuotes(quotes, oneForTwo, exactInput)
        const bestQuote = response?.bestQuote
        const partialAmount = response?.partialAmount
        if (bestQuote === undefined && partialAmount) {
            console.log('YSYS partial swap only available')
            throw new Error('not enough liquidity for this swap')
        }
        if (bestQuote === undefined) {
            throw new Error('amount too low')
        }
        return bestQuote
    } catch (e: any) {
        console.log('ERROR=', e)
        throw new Error(e.message)
    }
}
